import React from "react";
import { Text, type ChakraProps, type BoxProps } from "@chakra-ui/react";
import { textStyles } from "theme/text-styles";
import { capitalizeFirstLetter } from "utils";

type BadgeProps = {
  bg?: ChakraProps["bg"];
  color?: ChakraProps["color"];
} & BoxProps;

export function Badge({ bg = "new.gray.50", color = "brand.text.light", children, ...props }: BadgeProps & BoxProps) {
  return (
    <Text
      as="span"
      {...textStyles.caption2}
      bg={bg}
      borderRadius="smallest"
      color={color}
      fontWeight="semibold"
      p="tiny"
      sx={capitalizeFirstLetter}
      {...props}
    >
      {children}
    </Text>
  );
}
